import React from 'react';

interface SmsConsentCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Unique id so multiple forms can render the checkbox on the same page */
  id?: string;
  disabled?: boolean;
}

/**
 * A2P 10DLC-compliant SMS opt-in checkbox.
 * - Must be unchecked by default
 * - Consent must not be a condition of purchase
 * - Must disclose message frequency, rates, STOP/HELP, and link to policies
 * Keep this language in sync with SMS_CONSENT_TEXT in services/firebase.ts.
 */
const SmsConsentCheckbox: React.FC<SmsConsentCheckboxProps> = ({
  checked,
  onChange,
  id = 'smsConsent',
  disabled = false
}) => {
  return (
    <div className="p-4 bg-background-primary border border-border-primary rounded-lg">
      <label htmlFor={id} className="flex items-start space-x-3 cursor-pointer">
        <input
          type="checkbox"
          id={id}
          name="smsConsent"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          className="w-5 h-5 mt-0.5 text-gold-500 bg-background-primary border-border-primary rounded focus:ring-2 focus:ring-gold-500 flex-shrink-0 cursor-pointer"
        />
        <span className="text-xs text-text-secondary leading-relaxed">
          By checking this box, you agree to receive informational and appointment-related text
          messages (e.g., quotes, scheduling confirmations, service updates) from Elev8 Cleaning
          Solutions at the phone number provided. Consent is not a condition of purchase. Message
          frequency varies. Message &amp; data rates may apply. Reply{' '}
          <span className="font-semibold text-text-primary">STOP</span> to opt out or{' '}
          <span className="font-semibold text-text-primary">HELP</span> for help. See our{' '}
          <a
            href="/privacy-policy.html"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gold-500 hover:text-gold-400 underline"
          >
            Privacy Policy
          </a>{' '}
          and{' '}
          <a
            href="/terms-of-service.html"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gold-500 hover:text-gold-400 underline"
          >
            Terms of Service
          </a>
          .
        </span>
      </label>
    </div>
  );
};

export default SmsConsentCheckbox;
